/**
 * Maps an AI SDK UIMessage (what `useChat` holds) to assistant-ui's
 * ThreadMessageLike. Part semantics match today's renderers:
 * - text / reasoning pass through (reasoning is then hidden by the UI layer)
 * - dynamic-tool / static tool parts become tool-call parts keyed so the
 *   tool renderer receives the same { toolName, output } shape as before
 * - step-start/step-finish lifecycle parts are dropped (never painted)
 */
export const convertUiMessage = (message) => {
    const content = (message.parts || [])
        .map((part, index) => {
            if (part.type === "text") {
                return { type: "text", text: part.text };
            }
            if (part.type === "reasoning") {
                return { type: "reasoning", text: part.text };
            }
            if (part.type === "dynamic-tool" || part.type.startsWith("tool-")) {
                return {
                    type: "tool-call",
                    toolCallId: part.toolCallId || `${message.id}-${index}`,
                    toolName: part.toolName,
                    args: part.input,
                    result: part.output,
                    isError: part.state === "output-error"
                };
            }
            return null;
        })
        .filter(Boolean);

    return { id: message.id, role: message.role, content };
};
